export default "__VITE_ASSET__BT86Pcps__"